import React, { useEffect } from "react";
import Footer from "../../components/Footer";
import Navbar from "../../components/NavBar";
import "./privacy.css";

const Privacy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <Navbar />
      <section className="privacy">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <h1 className="mb-2">Privacy Policy</h1>
              {/* <p>Personal Information at GIGM.</p> */}
            </div>
          </div>
        </div>
      </section>
      <section className="privacy-text">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <h1 className="mb-2">
                Cardholder Privacy Policy for GIG Mobility (GIGM)
              </h1>
            </div>
            <div className="col-md-12">
              <label className="mb-2">
                <b>Introduction</b>
              </label>
              <p className="cardholder-privacy">
                GIG Mobility (GIGM) is committed to protecting your privacy.
                This notice explains our practices regarding any information
                that might be associated with a card payment transaction on our
                website and mobile apps. Importantly, GIGM does not collect,
                process, or store your payment card details as we do not process
                payment and do not hold a PCI-DSS license.
              </p>
              <label className="mb-2">
                <b>Scope of This Notice</b>
              </label>
              <p>
                This policy applies solely to any data related to payment card
                transactions that may be transmitted through our website and
                mobile apps. It is designed to clarify that GIGM’s role is
                limited to facilitating access to booking services; all payment
                processing functions are managed entirely by secured,
                third-party payment service providers.
              </p>
              <label className="mb-2">
                <b>No Collection or Storage of Card Details</b>
              </label>
              <p class="bills-list" style={{ alignItems: "flex-start" }}>
                <span
                  class="bullet"
                  style={{
                    width: "15px",
                    marginTop: "8px",
                    background: "black",
                  }}
                ></span>{" "}
                <span>
                  <b>No Card Data on Our Systems:</b> GIGM does not collect,
                  transmit, or store any payment card information. Any payment
                  card details entered on our website and mobile apps are sent
                  directly to our third-party payment processor through a secure
                  connection.
                </span>
              </p>
              <p class="bills-list" style={{ alignItems: "flex-start" }}>
                <span
                  class="bullet"
                  style={{
                    width: "10px",
                    marginTop: "8px",
                    background: "black",
                  }}
                ></span>{" "}
                <span>
                  <b>Third-Party Processing:</b> All payment card transactions
                  are handled by external providers that are fully PCI-DSS
                  compliant. GIGM has no access to, nor does it store, any
                  cardholder data.
                </span>
              </p>
              <label className="mb-2">
                <b>Limited Data Collection for Website Functionality</b>
              </label>
              <p class="bills-list" style={{ alignItems: "flex-start" }}>
                <span
                  class="bullet"
                  style={{
                    width: "15px",
                    marginTop: "8px",
                    background: "black",
                  }}
                ></span>{" "}
                <span>
                  <b>Technical and Analytical Data:</b> Like many websites, we
                  may automatically collect non-personally identifiable
                  information—such as your IP address, browser type, and
                  cookies—for the purposes of site analysis and to improve your
                  user experience. This data is not linked to any payment
                  information.
                </span>
              </p>
              <p class="bills-list" style={{ alignItems: "flex-start" }}>
                <span
                  class="bullet"
                  style={{
                    width: "10px",
                    marginTop: "8px",
                    background: "black",
                  }}
                ></span>{" "}
                <span>
                  <b>No Personal Cardholder Data:</b> Beyond the technical data
                  used for website performance and security, no personally
                  identifiable payment card information is collected or
                  processed by GIGM.
                </span>
              </p>
              <label className="mb-2">
                <b>User Responsibilities and Third-Party Policies</b>
              </label>
              <p class="bills-list" style={{ alignItems: "flex-start" }}>
                <span
                  class="bullet"
                  style={{
                    width: "13px",
                    marginTop: "8px",
                    background: "black",
                  }}
                ></span>{" "}
                <span>
                  <b>Review Third-Party Privacy Policies:</b> As all payment
                  processing is conducted by a third party, we strongly
                  encourage you to review the privacy policy of your chosen
                  payment provider for details on how your card data is handled,
                  stored, and secured.
                </span>
              </p>
              <p class="bills-list" style={{ alignItems: "flex-start" }}>
                <span
                  class="bullet"
                  style={{
                    width: "13px",
                    marginTop: "8px",
                    background: "black",
                  }}
                ></span>{" "}
                <span>
                  <b>Consent:</b> By proceeding with a booking on our platform,
                  you acknowledge that GIGM does not have custody of your
                  payment card details and that any such data is governed solely
                  by the third-party processor’s policies and security measures.
                </span>
              </p>

              <label className="mb-2">
                <b>Security Measures</b>
              </label>
              <p>
                While GIGM employs robust security practices to protect our
                website and your technical data, we emphasize that the security
                and integrity of your payment card information are managed by
                our PCI-DSS compliant payment service providers. GIGM does not
                intervene in or store these sensitive details.
              </p>
              <label className="mb-2">
                <b>No Liability for Payment Card Data Issues</b>
              </label>
              <p>
                By using our website and booking services, you agree that GIGM
                shall not be held liable for any loss, issues, disputes, or
                breaches related to the handling of your payment card
                information. All such matters are the responsibility and
                liability of the third-party payment processor.
              </p>
              <label className="mb-2">
                <b>Amendments to This Notice</b>
              </label>
              <p>
                GIGM reserves the right to update this Cardholder Privacy Notice
                from time to time. Any changes will be posted on our website,
                and your continued use of our services shall constitute your
                acceptance of such changes.
              </p>
              <label className="mb-2">
                <b>Contact Information</b>
              </label>
              <p>
                If you have any questions, concerns, or require further
                information regarding this policy or our data handling
                practices, please contact us at:
              </p>
              <label className="mb-2">
                <b>Email:</b>{" "}
                <a href="mailto: contact@gigm.com">
                  <span style={{ color: "#56CCF2" }}>contact@gigm.com.</span>
                </a>
              </label>

            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Privacy;
